import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { pageColors } from "../mock";
import { Instagram, ArrowRight, Music as MusicIcon } from "lucide-react";
import { MusicRequests } from "../components/MusicRequests";

const API = process.env.REACT_APP_BACKEND_URL;

const Music = () => {
  const navigate = useNavigate();
  const { current } = useAuth();
  const [approved, setApproved] = useState([]);

  useEffect(() => {
    document.title = "TMM|MUSIC";
    (async () => {
      try {
        const r = await fetch(`${API}/api/applications/approved/music`);
        const d = await r.json();
        setApproved(d.applications || []);
      } catch {
        /* ignore */
      }
    })();
  }, []);

  const canApply = current && current.status === "approved";

  return (
    <>
      <Header hoverColor={pageColors.music} compact={false} />
      <div className="music-page">
        <div className="music-banner" data-testid="music-banner">
          <img src="/img/ezmnybanner.webp" alt="EZ Money Records" />
        </div>

        <div className="music-intro">
          <p className="music-lead">
            <img src="/img/ezmnyrcrds.webp" alt="EZ Money Records" className="music-inline-mark" />
            was established in 2025 and is always looking for new talent. If
            you're a musician, producer, or engineer — put in your application
            and we'll be in touch.
          </p>
          <a
            className="music-ig"
            href="https://www.instagram.com/ez.mnyrcrdz/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="music-ig-link"
          >
            <Instagram size={16} /> @ez.mnyrcrdz
          </a>
        </div>

        <div className="music-apply-block">
          {canApply ? (
            <button
              className="btn-solid btn-huge"
              onClick={() => navigate("/apply/music")}
              data-testid="music-apply-btn"
            >
              <MusicIcon size={18} /> Apply to EZ Money Records <ArrowRight size={16} />
            </button>
          ) : (
            <div className="music-apply-gate" data-testid="music-apply-gate">
              <p>
                Only approved members can apply. {current ? "Your account is still pending admin approval." : (
                  <>
                    <button className="link-btn" onClick={() => navigate("/members")}>Sign up</button>
                    {" "}or log in first.
                  </>
                )}
              </p>
            </div>
          )}
        </div>

        <MusicRequests />

        {approved.length > 0 && (
          <section className="music-roster">
            <h2 className="music-roster-title">On the roster*</h2>
            <div className="music-roster-grid">
              {approved.map((a) => (
                <article key={a.id} className="roster-card" data-testid={`roster-card-${a.id}`}>
                  {a.hero_image_url && (
                    <div className="roster-cover">
                      <img src={a.hero_image_url} alt={a.display_name} />
                    </div>
                  )}
                  <div className="roster-body">
                    <div className="roster-name">{a.display_name}</div>
                    {a.tagline && <div className="roster-tag">{a.tagline}</div>}
                    <p className="roster-pitch">{a.pitch}</p>
                    <div className="roster-links">
                      {a.instagram && (
                        <a href={a.instagram.startsWith("http") ? a.instagram : `https://instagram.com/${a.instagram.replace(/^@/, "")}`} target="_blank" rel="noopener noreferrer">
                          <Instagram size={14} /> {a.instagram}
                        </a>
                      )}
                      {a.website && (
                        <a href={a.website} target="_blank" rel="noopener noreferrer">
                          website
                        </a>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default Music;
